import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCInriC8pzU84DJrvcmthgIg2ZTS_DE9WU",
  authDomain: "scrapper-4121b.firebaseapp.com",
  projectId: "scrapper-4121b",
  storageBucket: "scrapper-4121b.firebasestorage.app",
  messagingSenderId: "65257451842",
  appId: "1:65257451842:web:2bb23cd9cbf3a6c5f718db",
  measurementId: "G-R9VPK02QDS"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app); 